<template>
  <modal :show="showModal" @close="cancel" :modalHeight="450" :modal-width="370">
    <div class="row">
      <span class="color-header">{{ $t('views.switch.opstatus.header') }} {{ $t('views.switch')}} {{ railObjectName }}</span>
    </div>
    <div class="row">
      <span class="body2-menu">
        {{ $t('views.dashboard.selector.operationalstatus')}}
      </span>
    </div>
    <div class="row">
      <form action="#">
        <div class="col s3 offset-s1">
          <label>
            <input name="optOpMode" class="with-gap" type="radio" :value=1  v-model="newOperationMode"/>
            <span>{{ $t('operational') }}</span>
          </label>
        </div>
        <div class="col s3 offset-s2" >
          <label>
            <input name="optOpMode" class="with-gap" type="radio" :value=5  v-model="newOperationMode"/>
            <span>{{ $t('maintenance') }}</span>
          </label>
        </div>
      </form>
    </div>
    <div class="row">
    </div>
    <div class="row">
      <div class="infotext" v-html="infoText"></div>
    </div>
    <div class="row">
      <form class="col s12">
        <div class="row">
          <div class="col s8 offset-s2">
            <div class="input-field col s12">
              <textarea :placeholder="$t('views.switch.logentry.header')"   id="textarea1" v-model="logtext" class="materialize-textarea operationmode-textarea" rows="10" data-length="600"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row no-margin-bottom valign-wrapper">
        <div class="col s6 center-align">
          <a  @click="save()"
            class="waves-effect waves-light btn buttonbg NORMAL" >
              {{ $t('views.switch.opstatus.setstatus') }}
          </a>
        </div>
        <div class="col s6 center-align">
          <a class="button-label-primary" @click="cancel()">{{ $t('cancel') }}</a>
        </div>
    </div>
    <div class="row" v-if="showError">
      <div class="col s12  center-align text-danger">
        {{ error }}
      </div>
    </div>
  </modal>
</template>
<script>
import modal from './modal'
import Translation from '../../i18n/Translation'
import switchApi from '../../services/api/switch/SwitchApi'
import RailObjectService from '../../services/RailObjectService'
import moment from 'moment'

export default {
  name: 'OperationalStatus',
  props: {
    switchObject: {
      type: Object,
      default: () => {}
    },
    operationModeId: {
      type: Number,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      logtext: '',
      newOperationMode: this.operationModeId,
      updateObject: {
        RailObjectId: null,
        LogMessage: null,
        OperationModeId: null,
        DateTimeUpdated: null
      },
      error: this.$t('views.switch.update.error'),
      showError: false
    }
  },
  computed: {
    railObjectName: function () {
      if (this.switchObject) {
        return this.switchObject.Name
      } else {
        return ''
      }
    },
    infoText: function () {
      var value = this.$t('views.switch.opstatus.infotext')
      var maintenancetext = '<i>' + this.$t('maintenance').toLowerCase() + '</i>'
      var idxmaintenance = value.indexOf('5')
      // An 3 or 2 status of an object will be reverted after 5 1 measurements
      var result = value.substring(0, idxmaintenance)
      result += maintenancetext + ' ' + value.substring(idxmaintenance + 1, value.length)
      return result
    }
  },
  components: {
    modal,
    Translation
  },
  watch: {
    operationModeId: function (val) {
      this.newOperationMode = val
    }
  },
  methods: {
    save: function () {
      this.updateObject.RailObjectId = this.switchObject.RailObjectId
      this.updateObject.LogMessage = this.logtext
      if (this.updateObject.LogMessage.trim() === '') {
        this.updateObject.LogMessage = this.$t('views.switch.opmode.change')
      }
      this.updateObject.OperationModeId = this.newOperationMode
      this.updateObject.DateTimeUpdated = moment().toISOString(true)
      switchApi.changeOperationMode(this.updateObject)
        .then(response => {
          // this.$emit('update:lastMaintenanceDate', this.newMaintenanceDate)
          // var globalRobj = RailObjectService.getRailObjectByRailObjectId(this.switchObject.RailObjectId)
          // globalRobj.OperationModeId = this.newOperationMode
          // if (globalRobj.OperationModeId === 5) {
          //   globalRobj.LastMaintenanceDateTime = this.switchObject.LastMaintenanceDateTime = this.updateObject.DateTimeUpdated
          // }
          this.switchObject.OperationModeId = this.newOperationMode
          if (this.switchObject.OperationModeId === 5) {
            this.switchObject.LastMaintenanceDateTime = this.updateObject.DateTimeUpdated
          }
          RailObjectService.updateRailObject(this.switchObject)
          this.$emit('update:switchObject', this.switchObject)
          this.clear()
          this.$emit('update:showModal', false)
        })
        .catch(e => {
          console.log('error updateing last maintenance date', e)
          this.showError = true
        })
    },
    clear: function () {
      this.logtext = ''
      this.newOperationMode = null
      this.showError = false
    },
    cancel: function () {
      this.logtext = ''
      this.$emit('update:showModal', false)
    }
  }
}
</script>
<style scoped>
  .modal-mask {
    all: unset;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .modal-container {
    width: unset;
    height: 450px !important;
  }

  .modal-mask {
    all: unset;
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }
  .modal-container {
    width: 500px !important;
    height: 450px !important;
  }
  .warntext {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }
  .infotext {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.56);
  }
  .logheader {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    line-height: 12px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }
  .horizontal-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  .horizontal-list-item {
     display: inline-block;
  }
  .pad-5 {
    padding: 5;
  }
  .operationmode-textarea {
    height: 50px !important;
  }
  .buttonbg {
    background: #56CCF2;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }
  .NORMAL {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.0357143em;
    color: #FFFFFF;
  }
  .button-label-primary {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: #56CCF2;
    cursor: pointer;
  }
  [type="radio"]:checked + span:after,
  [type="radio"].with-gap:checked + span:before,
  [type="radio"].with-gap:checked + span:after {
    border: 2px solid #56CCF2;
  }
  [type="radio"]:checked + span:after,
  [type="radio"].with-gap:checked + span:after {
   background-color: #56CCF2;
 }
</style>



// WEBPACK FOOTER //
// src/components/switch/OperationalStatus.vue